export default {
  'code[class*="language-"]': {
    color: "#ffffff",
    background: "none",
    textShadow: "none",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "#ffffff",
    background: "#171717",
    textShadow: "none",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto",
    borderRadius: "0.3em"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#171717",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "#7a7a7a"
  },
  prolog: {
    color: "#7a7a7a"
  },
  doctype: {
    color: "#7a7a7a"
  },
  cdata: {
    color: "#7a7a7a"
  },
  punctuation: {
    color: "#e0e0e0"
  },
  ".namespace": {
    opacity: ".7"
  },
  property: {
    color: "#c36ff9"
  },
  tag: {
    color: "#c36ff9"
  },
  constant: {
    color: "#fa9557"
  },
  symbol: {
    color: "#c36ff9"
  },
  deleted: {
    color: "#c36ff9"
  },
  boolean: {
    color: "#fa9557"
  },
  number: {
    color: "#fa9557"
  },
  selector: {
    color: "#c36ff9"
  },
  "attr-name": {
    color: "#c36ff9"
  },
  string: {
    color: "#fa9557"
  },
  char: {
    color: "#fa9557"
  },
  builtin: {
    color: "#c36ff9"
  },
  inserted: {
    color: "#fa9557"
  },
  operator: {
    color: "#ffffff"
  },
  entity: {
    color: "#ffffff",
    cursor: "help"
  },
  url: {
    color: "#ffffff"
  },
  ".language-css .token.string": {
    color: "#fa9557"
  },
  ".style .token.string": {
    color: "#fa9557"
  },
  variable: {
    color: "#ffffff"
  },
  atrule: {
    color: "#c36ff9"
  },
  "attr-value": {
    color: "#fa9557"
  },
  function: {
    color: "#c36ff9"
  },
  "class-name": {
    color: "#d0b3ff"
  },
  keyword: {
    color: "#c36ff9"
  },
  regex: {
    color: "#fa9557"
  },
  important: {
    color: "#fa9557",
    fontWeight: "bold"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
};
